<template>
  <vs-table hover-flat v-if="announcements && announcements.length" :data="announcements">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('subject')"></vs-th>
      <vs-th v-text="$t('writer')"></vs-th>
      <vs-th v-if="isSeen" v-text="$t('seen')"></vs-th>
      <vs-th v-text="$t('date')"></vs-th>
      <vs-th class="text-center" v-if="isAction" v-text="$t('action')"></vs-th>
      <vs-th v-if="isView" v-text="$t('function')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="key" v-for="(tr, key) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td :data-tr-title="$t('subject')">
          <a href="#" @click.prevent="$emit('customClickView', tr.id)" v-text="tr.title"></a>
        </vs-td>
        <vs-td v-text="tr.user" :data-tr-title="$t('writer')"></vs-td>
        <vs-td v-if="isSeen" v-text="tr.announcement_seen_count" :data-tr-title="$t('seen')"></vs-td>
        <vs-td :data-tr-title="$t('date')">{{ tr.created_at | readableDate }}</vs-td>
        <vs-td v-if="isAction">
          <div class="flex justify-center">
            <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click.prevent="$emit('customClickEdit', tr.id)" v-if="isEdit"></vs-button>&nbsp;
            <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="$emit('customClickDelete', tr.id)"></vs-button>
          </div>
        </vs-td>
        <vs-td v-if="isView">
          <vs-button color="primary" type="border" icon-pack="feather" icon="icon-search"></vs-button>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Announcement.List',
  props: {
    announcements: {
      type: [Object, Array],
      required: true
    },
    isAction: {
      type: Boolean
    },
    isEdit: {
      type: Boolean
    },
    isSeen: {
      type: Boolean
    },
    isView: {
      type: Boolean
    }
  }
}
</script>

<style scoped>

</style>
